var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBankIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.51709 23.0604C0.51709 24.1531 1.3288 25.039 2.32392 25.039H33.6683C34.6634 25.039 35.4751 24.1531 35.4751 23.0604V10.358H0.51709V23.0604ZM21.7659 19.2673C21.7659 18.9941 21.9688 18.7717 22.2186 18.7717H32.6147C32.8644 18.7717 33.0634 18.9941 33.0634 19.2673V22.2331C33.0634 22.5063 32.8605 22.7287 32.6147 22.7287H22.2225C21.9727 22.7287 21.7698 22.5063 21.7698 22.2331V19.2673H21.7659ZM33.6761 0.960938H2.33172C1.3288 0.960938 0.524895 1.84679 0.524895 2.93947V6.90045H35.4868V2.93557C35.4829 1.84679 34.6712 0.960938 33.6761 0.960938Z",
    fill: "#5C5F62"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBankIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bank_icon.c7b2fcf23f0ea691f6f24009be150940.svg";